import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  const isActive = (p) => ((p === '/' ? path === '/' : path.startsWith(p)) ? 'active' : '');

  return (
    <header className="site-header">
      {/* Top utility bar */}
      <div className="header-top">
        <div className="container">
          <ul className="header-top-contact">
            <li><i className="fas fa-phone-alt"></i> +86 152 5809 2554</li>
            <li><i className="fas fa-envelope"></i> support@eaststarmarine.com</li>
          </ul>
          <div className="header-social">
            <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
            <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div className="header-main">
        <div className="container">
          <Link to="/" className="logo">
  <img 
    src={logo} 
    alt="East Star Marine " 
    style={{ width: "60px", height: "auto" }}
  />
</Link>

          <nav className="main-nav">
            <Link className={`nav-link ${isActive('/')}`} to="/">Home</Link>
            <Link className={`nav-link ${isActive('/about')}`} to="/about">About</Link>
            <Link className={`nav-link ${isActive('/products')}`} to="/products">Products</Link>
            <div className="nav-dropdown">
              <Link className={`nav-link ${isActive('/services')}`} to="/services"> Services </Link>
            </div>
            <Link className={`nav-link ${isActive('/contact')}`} to="/contact">Contact</Link>
          </nav>

          <div className="header-cta">
            <Link to="/contact" className="btn btn-primary">Get a Quote <i className="fas fa-arrow-right"></i></Link>
            <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)} aria-label="Open menu">
              <i className="fas fa-bars"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile overlay + drawer */}
      <div className={`mobile-nav-overlay ${mobileOpen ? 'open' : ''}`} onClick={() => setMobileOpen(false)} />
      <nav className={`mobile-nav ${mobileOpen ? 'open' : ''}`}>
        <button className="mobile-nav-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">
          <i className="fas fa-times"></i>
        </button>
        <div style={{ marginBottom: '20px' }}>
          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '19px', color: '#fff' }}>
             East Star  <span style={{ color: 'var(--orange)' }}>Marine</span>
          </span>
        </div>
        <Link to="/" onClick={() => setMobileOpen(false)}>Home</Link>
        <Link to="/about" onClick={() => setMobileOpen(false)}>About</Link>
        <Link to="/products" onClick={() => setMobileOpen(false)}>Products</Link>
        <Link to="/services" onClick={() => setMobileOpen(false)}>Services</Link>
        <Link to="/contact" onClick={() => setMobileOpen(false)}>Contact</Link>
        <div style={{ marginTop: '28px' }}>
          <Link to="/contact" className="btn btn-primary btn-block" onClick={() => setMobileOpen(false)}>Get a Quote</Link>
        </div>
        <div style={{ marginTop: '28px', fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>
          <p style={{ marginBottom: '8px' }}><i className="fas fa-phone-alt" style={{ color: 'var(--orange)', marginRight: '8px' }}></i>+86 152 5809 2554</p>
          <p><i className="fas fa-envelope" style={{ color: 'var(--orange)', marginRight: '8px' }}></i>support@eaststarmarine.com</p>
        </div>
      </nav>
    </header>
  );
}